import React from "react";
import lazyPage from "../../../common/helpers/lazyPage";
import Loader from "../Loader";

export default lazyPage(
    "src/front/components/CloneModal/CloneModal.tsx",
    () => import("./CloneModal"),
    <Loader margin="auto"/>,
);
